import styled from '@emotion/styled';
import { Tooltip, TextCaption, token } from '@ferreri/prever-component-lib';

type RuleTooltipProps = {
  max_quantity: number;
  hasAdditionalDependentGlobal: boolean;
};

export const RuleTooltip = (props: RuleTooltipProps) => {
  const limitExceededQuantity = props.max_quantity + 1;

  if (!props.max_quantity || props.max_quantity === 0) {
    return null;
  }

  return (
    <Tooltip
      title="Entenda a regra"
      content={
        <Container>
          <TextCaption>
            Você pode incluir até {props.max_quantity} deste grupo,
            independentemente do grau de parentesco.
          </TextCaption>
          {props.hasAdditionalDependentGlobal && (
            <TextCaption>
              Ao incluir {limitExceededQuantity} ou mais, aplica-se a regra dos
              dependentes adicionais.
            </TextCaption>
          )}
        </Container>
      }
    />
  );
};

const Container = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxxSmall};
  flex-direction: column;
`;
